import React from 'react';
import { useCasesContent } from '@anonymizePro/mock/contents';
import UseCasesCard from '@anonymizePro/components/cards/use-cases-card';

function Index() {
    return (
        <div className="layoutMarginAndRound flex w-full flex-col items-center bg-gradient-to-b from-blue-200 to-red-200 px-5 pb-[200px] pt-16 text-center md:px-10 lg:pb-[245px] lg:pt-[88px] xl:px-[128px]">
            <p className="anonymize-h2 text-black-800">{useCasesContent.title}</p>
            <p className="anonymize-p4 mb-16 mt-4 max-w-[307px] text-black-700">{useCasesContent.description}</p>
            <div className="grid grid-flow-row grid-rows-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {useCasesContent.useCases.map((useCase) => (
                    <UseCasesCard key={useCase.title} useCase={useCase} />
                ))}
            </div>
        </div>
    );
}

export default Index;
